import { motion } from 'motion/react';

const shopCardSpring = { type: 'spring', damping: 19, stiffness: 340 };

/** Градиент поверх арта: сверху чуть темнее под название, к низу — фиолетовый под бейдж и кнопку */
const CARD_SCRIM =
  'linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.12) 22%, transparent 38%, rgba(120,30,99,0.35) 48%, rgba(78,15,65,0.78) 68%, #2A0746 92%, #1a0522 100%)';

/**
 * Сетка паков токенов — тот же визуал, что {@link GameTokenPurchaseModal} в UI kit.
 * @param {object} props
 * @param {Array<{ _id: string, name: string, tokens: number, image?: string, priceDisplay: string }>} props.packs
 * @param {boolean} [props.loading]
 * @param {boolean} [props.error]
 * @param {(pack: object) => void} [props.onSelectPack]
 */
export default function GameTokenPurchasePanel({ packs, loading, error, onSelectPack }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center p-12 text-sm text-game-muted">Loading…</div>
    );
  }
  if (error) {
    return (
      <div className="flex items-center justify-center p-12 text-sm text-game-muted">
        Could not load packs.
      </div>
    );
  }
  if (!packs?.length) {
    return (
      <div className="flex items-center justify-center p-12 text-sm text-game-muted">
        No packs available.
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-3">
        {packs.map((p, i) => (
          <motion.button
            key={String(p._id)}
            type="button"
            layout
            initial={{ opacity: 0, y: 14, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ ...shopCardSpring, delay: i * 0.07 }}
            whileHover={{
              y: -4,
              transition: { type: 'spring', stiffness: 400, damping: 22 }
            }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onSelectPack?.(p)}
            className="group relative flex min-h-[240px] w-full flex-col justify-between overflow-hidden rounded-2xl border border-white/10 text-left shadow-md transition-colors duration-150 hover:border-game-accent/40 hover:shadow-lg hover:shadow-game-accent/[0.08] sm:min-h-[260px]"
          >
            {p.image?.trim() ? (
              <img
                src={p.image.trim()}
                alt=""
                className="absolute inset-0 z-0 h-full w-full object-cover"
                draggable={false}
              />
            ) : (
              <div
                className="absolute inset-0 z-0 bg-gradient-to-br from-game-accent/40 via-game-menuTop to-game-purpleDeep"
                aria-hidden
              />
            )}
            <div
              className="pointer-events-none absolute inset-0 z-[1]"
              style={{ background: CARD_SCRIM }}
              aria-hidden
            />
            <div className="pointer-events-none absolute inset-x-5 top-3 z-[2] h-px bg-gradient-to-r from-transparent via-game-accent/40 to-transparent opacity-0 transition-opacity duration-200 group-hover:opacity-100" />

            <div className="relative z-[3] w-full px-4 pb-1 pt-4">
              <p className="line-clamp-2 text-sm font-bold leading-snug tracking-tight text-game-text drop-shadow-[0_2px_10px_rgba(0,0,0,0.9)]">
                {p.name}
              </p>
            </div>

            <div className="relative z-[3] mt-auto flex w-full flex-col items-stretch px-4 pb-4 pt-8">
              <p className="mx-auto mt-0 inline-flex max-w-full items-center justify-center gap-1.5 rounded-lg border border-white/20 bg-black/60 px-3 py-1.5 text-sm font-bold tabular-nums tracking-wide text-game-text shadow-[0_2px_12px_rgba(0,0,0,0.55)] backdrop-blur-sm">
                <span className="shrink-0 text-base leading-none text-game-accent drop-shadow-sm" aria-hidden>
                  ◆
                </span>
                <span className="min-w-0">
                  {p.tokens} tokens
                </span>
              </p>
              <span className="mt-4 w-full rounded-xl bg-game-accent py-2.5 text-center text-xs font-bold text-game-accentText shadow-md shadow-black/35 transition-colors duration-150 group-hover:bg-game-accentHover">
                {p.priceDisplay}
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
